/**
 * CSRProfileDropdown.jsx
 * Created by Hassan Riaz on 1/16/20.
 */

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Button from '../../sharedComponents/Button';
import DropdownBase from '../../sharedComponents/DropdownBase';
import * as Icons from '../../sharedComponents/icons/Icons';


import { ACCOUNT_PROPS, CSR_ACCOUNT_PROPS } from '../constants';

const CSRSelectButton = (props) => {
    const {
        hasSelectedCustomer,
        fullName,
        innerRef,
        isDisabled,
        ...rest
    } = props;

    return (
        <button
            ref={innerRef}
            disabled={isDisabled}
            className={cx('rec-select', {
                'rec-csr-profile': !hasSelectedCustomer,
                'rec-csr-customer-profile': hasSelectedCustomer
            })}
            {...rest}>
            <span className="rec-csr-profile-icon-wrap">
                <Icons.IconPerson />
            </span>
            <span className="rec-select-label">
                {fullName}
            </span>
            <span className="rec-select-icon">
                <Icons.IconArrowDown />
            </span>
        </button>
    );
}

CSRSelectButton.propTypes = {
    hasSelectedCustomer: PropTypes.bool,
    fullName: PropTypes.string,
    innerRef: PropTypes.any,
    isDisabled: PropTypes.bool,
    isExpanded: PropTypes.bool
};

export default class CSRProfileDropdown extends React.PureComponent {
    static propTypes = {
        account: ACCOUNT_PROPS,
        csrAccount: CSR_ACCOUNT_PROPS,
        openSelectCustomerModal: PropTypes.func,
        signOut: PropTypes.func
    };

    static defaultProps = {
        account: {},
        signOut: () => { }
    };

    render() {
        let fullName = '';

        if (this.props.csrAccount) {
            // Set the CSR user profile style
            fullName = `(CSR) ${this.props.csrAccount.name}`;
        }

        if (this.props.account) {
            const firstName = this.props.account.account.first_name;
            const lastInitial = this.props.account.account.last_name[0];
            fullName = firstName;
            if (lastInitial && lastInitial.length > 0) {
                fullName = `(Customer) ${firstName} ${lastInitial}.`;
            }
        }

        const Trigger = (
            <CSRSelectButton
                fullName={fullName}
                hasSelectedCustomer={!!this.props.account} />
        )

        return (
            <div className="nav-profile-dropdown">
                <DropdownBase
                    id="csr-options"
                    triggerButtonElement={Trigger}
                    applyButtonLabel="Close">
                    <div className="sarsa-csr-options-dropdown-inner">
                        <div>
                            <Button
                                appearance="link"
                                shouldFitContainer
                                onClick={this.props.openSelectCustomerModal}>
                                Select Customer
                            </Button>
                        </div>
                        <div>
                            <Button
                                appearance="link"
                                shouldFitContainer
                                onClick={this.props.signOut} >
                                Sign Out
                            </Button>
                        </div>
                    </div>
                </DropdownBase>
            </div>
        );
    }
}
